import { ReactNode, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { theme } from './common/theme'
import { AppProvider } from './AppContext'
import CookieBar from './tabs/CookieBar'
import LoginPage from './pages/LoginPage'
import AppPage from './pages/AppPage'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

function RequireAuth({ children }: { children: ReactNode }) {
  const token = document.cookie.match(/cfp_access_token=([^;]+)/)?.[1]
  if (!token) return <Navigate to="/login" replace />
  return <>{children}</>
}

function AppContent() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/app/*" element={<RequireAuth><AppPage /></RequireAuth>} />
        <Route path="/" element={<Navigate to="/app" replace />} />
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Routes>
      <CookieBar />
    </>
  )
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </AppProvider>
    </ThemeProvider>
  )
}
